import {
  container,
  title,
  cardTitle,
  grayColor,
  coloredShadow
} from "../../../material-kit-pro-react";
import { createStyles } from "@material-ui/core";

const sectionSimilarStoriesStyle = createStyles({
  container,
  title,
  cardTitle,
  coloredShadow,
  textCenter: {
    textAlign: "center"
  },
  section: {
    backgroundPosition: "50%",
    backgroundSize: "cover",
    padding: "70px 0"
  },
  description: {
    color: grayColor[0]
  }
});

export default sectionSimilarStoriesStyle;
